import { CUSTOM_ELEMENTS_SCHEMA, Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


// OTHER MODULE IMPORTS

import { SharedModule } from './../../shared.module';
import { MaterialsModule } from './../../materials.module';
import { MainTimesheetRoutingModule } from './main-timesheet-routing.module';


// IMPORT TIMESHEET MODULE COMPONENTS
import { MainTimesheetComponent } from './main-timesheet.component';
import { TimeSheetComponent } from '../time-sheet.component';
import { TimeSheetSummaryComponent } from '../time-sheet-summary/time-sheet-summary.component';
import { WeekListComponent } from '../week-list/week-list.component';
import { SingleWeekComponent } from '../single-week/single-week.component';
import { AdminTimeSheetComponent } from '../admin-time-sheet/admin-time-sheet.component';
import { InstructorConfirmationModalComponent } from '../admin-time-sheet/instructor-confirmation-modal/instructor-confirmation-modal.component';
import { AdminReportAComponent } from '../admin-report-a/admin-report-a.component';
import { AdminReportBComponent } from '../admin-report-b/admin-report-b.component';
import { UserSingleWeekComponent } from '../user-single-week/user-single-week.component';
import { DefaultFatigueValuesComponent } from '../../fatigue/default-fatigue-values/default-fatigue-values.component';


@NgModule({
  declarations: [
    MainTimesheetComponent,
    TimeSheetComponent,
    TimeSheetSummaryComponent,
    WeekListComponent,
    SingleWeekComponent,
    AdminTimeSheetComponent,
    InstructorConfirmationModalComponent,
    AdminReportAComponent,
    AdminReportBComponent,
    UserSingleWeekComponent,
    DefaultFatigueValuesComponent
  ],
  imports: [
    CommonModule,
    MainTimesheetRoutingModule,
    SharedModule,
    MaterialsModule,
  ],
  exports: [
    UserSingleWeekComponent
  ],
  entryComponents: [
    InstructorConfirmationModalComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

@Injectable({
  providedIn: UserSingleWeekComponent
})

export class MainTimesheetModule { }
